/* Infinite scroll for collection pages.

   Replaces the numbered pagination with automatic loading: when the shopper
   nears the bottom, the next page's products are fetched and appended to the
   grid.

   Progressive enhancement - the native pagination is only hidden once this
   script has successfully initialised, and it is put back if a fetch fails, so
   the shop is never left without a way to reach page 2.

   Plays nicely with the theme's ajax filtering: filtering/sorting replaces the
   contents of every [data-ajax-container], so all elements are re-queried on
   each use and a MutationObserver re-syncs state afterwards.
*/
(function () {
  var LISTING = '.collection-listing';
  var GRID = '.collection-listing .product-grid';
  var PAG_ROW = '.pagination-row';
  var MAX_FAILURES = 2;

  var state = {
    loading: false,
    done: false,
    failures: 0,
    requested: {},
    sentinel: null,
    status: null,
    observer: null
  };

  function grid() { return document.querySelector(GRID); }
  function pagRow() { return document.querySelector(PAG_ROW); }

  function nextUrl() {
    var row = pagRow();
    if (!row) return null;
    var link = row.querySelector('.pagination__next');
    return link ? link.getAttribute('href') : null;
  }

  // Native pagination stays in the DOM (the theme's ajax filtering rewrites it)
  // but is hidden while infinite scroll is driving the page.
  function hidePagination() { document.body.classList.add('has-infinite-scroll'); }
  function showPagination() { document.body.classList.remove('has-infinite-scroll'); }

  function setStatus(text) {
    if (state.status) state.status.textContent = text || '';
  }

  function buildSentinel() {
    var row = pagRow();
    if (!row || !row.parentElement) return false;

    if (!state.sentinel || !state.sentinel.isConnected) {
      state.sentinel = document.createElement('div');
      state.sentinel.className = 'infinite-scroll-sentinel';
      state.status = document.createElement('div');
      state.status.className = 'infinite-scroll-status';
      state.sentinel.appendChild(state.status);
      // Inserted as a sibling of the pagination row, never inside it: the row's
      // innerHTML is replaced wholesale when a filter is applied.
      row.parentElement.insertBefore(state.sentinel, row.nextSibling);
    }
    return true;
  }

  var THRESHOLD = 800;

  // An IntersectionObserver only fires on transitions. After a page is appended
  // the sentinel often stays inside the viewport, so no further callback would
  // arrive and loading would stall until the shopper scrolled again. Every
  // trigger therefore goes through maybeLoad(), which measures the sentinel.
  function maybeLoad() {
    if (state.loading || state.done || !state.sentinel || !state.sentinel.isConnected) return;
    var rect = state.sentinel.getBoundingClientRect();
    if (rect.top <= (window.innerHeight || 0) + THRESHOLD) load();
  }

  function observe() {
    if (state.observer) state.observer.disconnect();
    state.observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) maybeLoad();
      });
    }, { rootMargin: THRESHOLD + 'px 0px' });
    state.observer.observe(state.sentinel);
    maybeLoad();
  }

  function load() {
    if (state.loading || state.done) return;
    var url = nextUrl();
    if (!url) { state.done = true; return; }
    if (state.requested[url]) return;
    state.requested[url] = true;

    var container = document.querySelector('filter-container');
    var sectionId = container && container.dataset.filterSectionId;
    var fetchUrl = url;
    if (sectionId) {
      fetchUrl += (url.indexOf('?') >= 0 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
    }

    state.loading = true;
    setStatus('טוען עוד מוצרים…');

    fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var parsed = document.createElement('template');
        parsed.innerHTML = html;

        var newGrid = parsed.content.querySelector(GRID) || parsed.content.querySelector('.product-grid');
        var currentGrid = grid();
        if (!newGrid || !currentGrid) throw new Error('grid not found in response');

        var added = 0;
        Array.prototype.slice.call(newGrid.children).forEach(function (card) {
          currentGrid.appendChild(document.importNode(card, true));
          added += 1;
        });

        // Swap in the fetched pagination so the next link advances.
        var newPagRow = parsed.content.querySelector(PAG_ROW);
        var currentPagRow = pagRow();
        if (newPagRow && currentPagRow) currentPagRow.innerHTML = newPagRow.innerHTML;

        state.failures = 0;
        state.loading = false;
        setStatus('');

        if (added === 0 || !nextUrl()) {
          state.done = true;
          if (state.observer) state.observer.disconnect();
        } else {
          maybeLoad();
        }
      })
      .catch(function (error) {
        state.loading = false;
        delete state.requested[url];
        state.failures += 1;
        if (state.failures >= MAX_FAILURES) {
          // Give the shopper the numbered pagination back rather than trapping
          // them on page 1.
          state.done = true;
          if (state.observer) state.observer.disconnect();
          showPagination();
          setStatus('');
        } else {
          setStatus('');
        }
        if (window.console) console.warn('[infinite-scroll]', error); // eslint-disable-line no-console
      });
  }

  // Re-read everything after the theme swaps container contents (filter/sort).
  function sync() {
    if (!grid() || !pagRow()) return;
    state.loading = false;
    state.done = false;
    state.failures = 0;
    state.requested = {};
    if (!buildSentinel()) return;
    if (nextUrl()) {
      hidePagination();
      observe();
    } else {
      // Single page of results: nothing to hide, nothing to watch.
      hidePagination();
      if (state.observer) state.observer.disconnect();
    }
  }

  function init() {
    if (!grid() || !pagRow()) return;
    if (!('IntersectionObserver' in window)) return;
    sync();

    var scrollTimer = null;
    var onScroll = function () {
      if (scrollTimer) return;
      scrollTimer = setTimeout(function () { scrollTimer = null; maybeLoad(); }, 150);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    var listing = document.querySelector(LISTING);
    if (listing && 'MutationObserver' in window) {
      var debounceTimer = null;
      var mo = new MutationObserver(function () {
        clearTimeout(debounceTimer);
        // Only a filter/sort load replaces the grid element itself; appending
        // cards keeps the same node, so compare before re-syncing.
        debounceTimer = setTimeout(function () {
          if (!state.loading) sync();
        }, 300);
      });
      mo.observe(listing, { childList: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
